import { DefaultState } from 'store/types';

export const ADD_LODGING_OPTION_DATA_REQUEST = 'ADD_LODGING_OPTION_DATA_REQUEST';
export const ADD_LODGING_OPTION_DATA_SUCCESS = 'ADD_LODGING_OPTION_DATA_SUCCESS';
export const ADD_LODGING_OPTION_DATA_FAILURE = 'ADD_LODGING_OPTION_DATA_FAILURE';

export interface AddLodgingOptionParams {
  name: string;
  lodgingType: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  location: {
    longitude: number;
    latitude: number;
  };
  checkInDetails?: string;
  checkOutDetails?: string;
  notes?: string;
  website?: string;
  lodgingManager: {
    name: string;
    phoneNumber: string;
    email?: string;
  };
};
export interface AddLodgingOptionData {
  id: string;
}

export type AddLodgingOptionState = DefaultState & {
  contents?: AddLodgingOptionData;
};

interface AddLodgingOptionDataRequest {
  type: typeof ADD_LODGING_OPTION_DATA_REQUEST;
};

interface AddLodgingOptionDataSuccess {
  type: typeof ADD_LODGING_OPTION_DATA_SUCCESS,
  contents: AddLodgingOptionData;
}

interface AddLodgingOptionDataFailure {
  type: typeof ADD_LODGING_OPTION_DATA_FAILURE;
}

export type AddLodgingOptionActionTypes = AddLodgingOptionDataRequest | AddLodgingOptionDataSuccess | AddLodgingOptionDataFailure;